import { useCallback, useRef } from 'react';

export const useTapToOpen = (shouldEnable: boolean) => {
  const hasUserTappedRef = useRef(false);

  const handleTap = useCallback(
    (event: React.MouseEvent, isPopoverCurrentlyVisible: boolean) => {
      if (!shouldEnable) {
        return false;
      }

      // If popover not visible and user hasn't tapped before, prevent navigation
      if (!isPopoverCurrentlyVisible && !hasUserTappedRef.current) {
        event.preventDefault();
        hasUserTappedRef.current = true;

        return true;
      }

      return false;
    },
    [shouldEnable]
  );

  const resetTapState = useCallback(() => {
    hasUserTappedRef.current = false;
  }, []);

  return {
    handleTap,
    resetTapState,
  };
};
